module.exports = __webpack_public_path__ + "static/media/brand-story-meaning9.0d3c19a4.png";